import { Directive, HostListener } from '@angular/core';

@Directive({
	selector: '[rbcClickListener]'
})
export class ClickListenerDirective {
	constructor() {}

	@HostListener('document:click', ['$event.target'])
	clickout(target: Element) {
		const openedElements = document.querySelectorAll('[data-rbcfw-alt-open]');
		if (openedElements.length > 0) {
			const event = new CustomEvent('rbcDocumentClick', { detail: target });
			openedElements.forEach((item: Element) => {
				item.dispatchEvent(event);
			});
		}
	}

	@HostListener('document:touchend', ['$event.target'])
	touchend(target: Element) {
		const openedElements = document.querySelectorAll('[data-rbcfw-alt-open]');
		if (openedElements.length > 0) {
			const event = new CustomEvent('rbcDocumentClick', { detail: target });
			openedElements.forEach((item: Element) => {
				item.dispatchEvent(event);
			});
		}
	}
}
